module.exports = __webpack_public_path__ + "img/test_r12.dba2a23a.png";